import { Type } from 'typescript-json-serializer/dist/helpers';

import { httpClientFunction } from 'domain/types';
import { MessageResponse, deserializeArrayResponse, deserializeResponse, deserializeNoContentResponse } from 'adapter/out/serializer';

export const getApiClient = <T extends object, O, P extends object, Q>(
    buildPath: (criteria: O) => string,
    classType: Type<T> | T,
    buildRequestInit: (criteria: O) => RequestInit = () => ({} as RequestInit),
    mapper?: (json: P) => Q
) => (httpClient: httpClientFunction, baseUrl: string) => (criteria: O) =>
    deserializeResponse(httpClient(`${baseUrl}/${buildPath(criteria)}`, buildRequestInit(criteria)), classType, mapper);

export const getArrayApiClient = <T extends object, O, P extends object, Q>(
    buildPath: (criteria: O) => string,
    classType: Type<T> | T,
    buildRequestInit: (criteria: O) => RequestInit = () => ({} as RequestInit),
    mapper?: (json: P) => Q
) => (httpClient: httpClientFunction, baseUrl: string) => (criteria: O) =>
    deserializeArrayResponse(httpClient(`${baseUrl}/${buildPath(criteria)}`, buildRequestInit(criteria)), classType, mapper);

export const getNoContentApiClient = <O>(
    buildPath: (criteria: O) => string,
    buildRequestInit: (criteria: O) => RequestInit = () => ({} as RequestInit),
    mapper?: () => MessageResponse
) => (httpClient: httpClientFunction, baseUrl: string) => (criteria: O) =>
    deserializeNoContentResponse(httpClient(`${baseUrl}/${buildPath(criteria)}`, buildRequestInit(criteria)), mapper);
